import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IIndirectTaxFilingV2FrequencyChangeLogListResponse,
  IIndirectTaxFilingV2FrequencyChangeLogsParams,
} from './types';

export function useIndirectTaxFilingV2FrequencyChangeLogs(
  params: IIndirectTaxFilingV2FrequencyChangeLogsParams & { enabled?: boolean }
) {
  const { enabled = true, ...rest } = params;
  const query = new URLSearchParams();

  query.append('corporationId', rest.corporationId.toString());
  query.append('registrationTaxTypeId', rest.registrationTaxTypeId);
  if (rest.cursor) {
    query.append('cursor', rest.cursor);
  }
  if (rest.limit) {
    query.append('limit', rest.limit.toString());
  }

  const key = enabled
    ? `new-sales-tax/filings-v2/frequency-change-logs?${query.toString()}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2FrequencyChangeLogListResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    changes: data?.changes ?? [],
    count: data?.count ?? 0,
    nextCursor: data?.nextCursor ?? null,
    globalizationPending: data?.globalizationPending ?? false,
    isLoading,
    error,
    mutate,
  };
}
